<template>
  <v-container
    fluid>
    <v-row
    >
      <v-col
        cols="12"
        v-if="documents.length === 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No {{ documentsName.toLowerCase() }} have been published.
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        v-for="(documentCategory, i) in documents"
        :key="i">
        <v-card class="mb-3">
          <v-card-title class="font-weight-bold">{{ documentCategory.categoryName }}</v-card-title>
          <a
            v-for="document in documentCategory.files"
            :key="document.filename"
            :href="document.link"
            class="black--text font-weight-bold"
            style="text-decoration: none;"
            target="_blank">
            <v-card-text>
              <v-icon>{{ getFileIcon(document.filename) }}</v-icon>
              <span class="font-weight-bold ml-1">{{ document.filename }}</span>
              <span
                class="caption ml-1"
                v-if="document.description !== ''">- {{ document.description }}</span>
            </v-card-text>
            <v-divider/>
          </a>
          <a
            v-if="documentCategory.files.length === 0"
            class="black--text"
            style="text-decoration: none;"
            target="_blank">
            <v-card-text>
              <v-icon/>
              <span class="ml-1">No {{ documentsName.toLowerCase() }} have been published.</span>
            </v-card-text>
            <v-divider/>
          </a>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    documents: {
      type: Array,
      default: function () {
        return []
      }
    },
    documentsName: {
      type: String,
      default: 'Documents'
    }
  },

  methods: {
    getFileIcon: function (fileName) {
      var fileExtension = fileName.substr(fileName.lastIndexOf('.')).split('.')[1]
      if (fileExtension === 'pdf') {
        return 'fa-file-pdf'
      } else if (fileExtension === 'doc' || fileExtension === 'docx') {
        return 'fa-file-word'
      } else {
        return 'fa-file-alt'
      }
    }
  }
}
</script>
